import { render, staticRenderFns } from "./GalleryProjectImage.vue?vue&type=template&id=3f42c0ab"
import script from "./GalleryProjectImage.vue?vue&type=script&lang=js"
export * from "./GalleryProjectImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports